import type { FC, ReactNode } from "react";
import { createPortal } from "react-dom";
import { usePortalScope } from "./DPortalScopeProvider.tsx";

interface Props {
  target: string;
  children: ReactNode;
}

const DPortal: FC<Props> = ({ target, children }) => {
  const [element, setElement] = useState<HTMLElement | null>(null);
  const scope = usePortalScope();

  useEffect(() => {
    const ownedTarget = target === "d-app-content" || target === "d-app";
    setElement(
      ownedTarget && scope !== undefined
        ? scope
        : (document.getElementById(target) ?? document.body),
    );
  }, [scope, target]);

  return element ? createPortal(children, element) : null;
};

export default DPortal;
